export const user_api = {
  settings: '/api/v1/users/settings',
  switcher: '/api/v1/experiment/swh/user',
};
export const activity_api = {
  list: '/community/api/activity-list',
  detail: '/community/api/activity/detail',
  works_list: '/community/api/activity/works-list',
  works_detail: '/community/api/activity/works-detail',
  works_in_act: '/community/api/activity/works-in-act',
  user_doc_search: '/community/api/activity/user-doc-search',
  user_doc_pub: '/community/api/activity/user-doc-pub',
  res_info: '/community/api/activity/res-info',
  user_doc_copy:'/community/api/user-doc-copy'
  
};
export const report_api = {
  is_reports: '/community/api/is-reported',
  resource_report: '/community/api/resource-report',
  report_info: '/community/api/report-info',
};


export const hot_api = {
  hot_resource: '/community/api/hot-resource',
  hot_favorite: '/community/api/hot-favorite',
  hot_copy: '/community/api/hot-copy-success',
};

export const badage_api = {
  badage_action: '/community/api/badges/action',
};
